<template>
  <div class="body_left">
    <div class="left_top no_mobile">
      <img src="@/images/topic_thum_54.png" alt="" />회사관리
    </div>
    <div class="left_body">
      <ul class="menu">
        <li>
          <router-link
            to="/company/list"
            :class="{ on: selectedMenu === 0 }"
             @click.prevent="handleMenuClick(0, '/company/list')"
          >
            회사목록
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Company_Left",
  data() {
    return {
      selectedMenu: null,
    };
  },
  computed: {
    selectedtopMenu() {
      return this.$store.getters.getSelectedMenu;
    },
  },
  methods: {
    selectMenu(index, menuPath) {
      this.selectedMenu = index;
      this.$store.dispatch("updateSelectedMenu", "/company/management"); // Vuex 상태 업데이트
    },
    updateSelectedMenu() {
      const path = this.$route.path;
      if (path === "/company/management" || path === "/company/list") {
        this.selectedMenu = 0;
      } else if (path === "/company/view") {
        this.selectedMenu = 0;
      }
      this.$store.dispatch("updateSelectedMenu", "/company/management"); // Vuex 상태 업데이트
    },
    handleMenuClick(index, menuPath) {
      if (this.$route.path === menuPath) {
        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.replace(menuPath);
        });
      } else {
        this.selectMenu(index);
        this.$router.push(menuPath);
      }
    },
  },
  watch: {
    $route() {
      this.updateSelectedMenu();
    },
  },
  mounted() {
    this.updateSelectedMenu();
  },
};
</script>

<style scoped></style>
